import { Grid, Typography } from "@mui/material";
import { t } from "i18next";
import React from "react";
import { TransactionRecordItemProps } from "../../../interfaces/CategoryTransactionInterface";


const TransactionRecordItem = (props: TransactionRecordItemProps) => {

    const { transactionRecord, getFlagStatus, getRequestStatus } = props;
    return (
        transactionRecord &&
        <Grid container mb={2} sx={{marginTop : 2}}>
            <Grid container xs={12} sm={4} md={3} lg={2}>
                <Grid>
                    <Typography variant="body1">{t("category_management.category_code")}</Typography>
                </Grid>
                <Grid>
                    <Typography variant="body1">&nbsp;：{transactionRecord?.categoryCode}</Typography>
                </Grid>
            </Grid>
            <Grid container xs={12} sm={4} md={3} lg={2}>
                <Grid>
                    <Typography variant="body1">{t("category_management.publication_status")}</Typography>
                </Grid>
                <Grid>
                    <Typography variant="body1">&nbsp;：{getFlagStatus(transactionRecord?.publicFlag.toString()) ?? "-"}</Typography>
                </Grid>
            </Grid>
            <Grid container xs={12} sm={4} md={3} lg={2}>
                <Grid>
                    <Typography variant="body1">{t("category_management.request_status")}</Typography>
                </Grid>
                <Grid>
                    <Typography variant="body1">&nbsp;：<span style={{ color: transactionRecord?.requestStatus === 3 ? "red" : "" }}> {getRequestStatus(transactionRecord?.requestStatus)} </span></Typography>
                </Grid>
            </Grid>
        </Grid>
    );
};

export default TransactionRecordItem;